import { network } from 'services/network';

export const roleDelete = (params: string) => {
    const url = `admin/bo/roleDelete/${params}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
